<template>
  <div class="template-project-detail" v-loading="loading">
    <div class="header">
      <div class="top">
        <Breadcrumb @save="saveTemplate" @del="handleDelTemplate"></Breadcrumb>
      </div>
      <div class="tabs-box">
        <el-tabs v-model="activeName">
          <el-tab-pane label="任务" name="task"> </el-tab-pane>
          <el-tab-pane label="文件" name="file"> </el-tab-pane>
        </el-tabs>
        <div class="tabs-right-box">
          <div class="view-ch">
            <!-- <ModeCheck></ModeCheck> -->
            <span>默认视图：</span>
            <el-radio-group v-model="dataset.default_view" size="mini">
              <el-radio :label="1">看板</el-radio>
              <el-radio :label="2">列表</el-radio>
              <el-radio :label="3">甘特图</el-radio>
            </el-radio-group>
          </div>
           <HeadKey :templateKey="dataset.task_template_content ? dataset.task_template_content.template_standard_components : []" @showCustom="showCustom"></HeadKey>
        </div>
      </div>
    </div>
    <div class="board-tip">项目模版部分功能不可用</div>
    <template v-if="activeName === 'task'">
      <div class="board-menu" v-if="dataset.project_template_content && dataset.project_template_content.task_list">
        <vuedraggable class="move-box" ref="move-box" v-bind="subDragOptions('listId')" :list="dataset.project_template_content.task_list" handle=".task-drag-box" @end="end">
          <div class="board-menu-item" v-for="(item, index) in dataset.project_template_content.task_list" :key="item.task_list_id">
            <div class="task-msgcount-super" v-if="item.msgCount > 0">{{ item.msgCount > 99 ? "99+" : item.msgCount }}</div>
            <div class="board-content-title">
              <div class="task-drag-box-f">
                <i class="icon iconfont iconicon_drag_order task-drag-box"></i>
              </div>
              <div class="title-flex-box" v-if="!item.isTitleEdit">
                <div @click="editTitle(item,`inputs-${item.task_list_id}`)" class="title">
                  <toolTip style="width: 100%" :title="item.title">
                    <span class="title-txtpos">{{ item.title }}</span>
                  </toolTip>
                </div>
              </div>
              <div class="title-input" v-else>
                <el-input :ref="`inputs-${item.task_list_id}`" v-model="item.title" @blur="changeTitle(item)" @keyup.enter.native="enterTitleChange(`inputs-${item.task_list_id}`)"></el-input>
              </div>
              <div class="btns-handler">
                <el-dropdown class="dot-more" @command="handleCommandAddtask" size="small" trigger="click"  :class="{'visibleActive': item.moreShow}" @visible-change="changeListShow(item)">
                  <el-tooltip class="item" effect="dark" content="更多选项" placement="top">
                    <span class="task-sn-hover taskHoverIcon">
                      <i class="icon iconfont iconicon_more_task1"></i>
                    </span>
                  </el-tooltip>
                  <el-dropdown-menu slot="dropdown" class="tasklist-title-more">
                    <el-dropdown-item :command="{ type: 'delChecklist', item, index }" >
                      <i class="icon iconfont iconicon_recycle_bin"></i>
                      <span>删除</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-tooltip class="item" effect="dark" content="添加任务" placement="top">
                  <i class="icon iconfont iconicon_enlarge tableIconHover add-icon" @click="addTask(item)"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="board-content" ref="board-content" :data-list="item.task_list_id" :data-index="index">
              <el-collapse-transition>
                <div class="task-move-box" :ref="'board_'+ item.task_list_id + '_tasks'">
                  <vuedraggable class="task-item-move" v-bind="subDragOptions('listTask')" :list="item.tasks">
                    <div v-for="(val, index) in item.tasks" :key="index" >
                      <Task :dataset="val" @handleCommand="handleCommand" type="unArch" @click.native="editTask" @click="taskClick(val, index, item.task_list_id)"></Task>
                    </div>
                  </vuedraggable>
                  <wf-button class="add-task" icon="icon iconfont iconicon_enlarge" auto card @click="addTask(item)"></wf-button>
                </div>
              </el-collapse-transition>
            </div>
          </div>
        </vuedraggable>
        <div class="board-menu-item board-content---addlist" >
          <div @click="addChecklist" class="add-btn">
            <span class="btnHover"><i class="icon iconfont iconicon_new_subproject"></i>添加任务清单</span>
          </div>
        </div>
      </div>
      <el-tooltip class="task-list-add" effect="dark" content="添加任务清单" placement="top">
        <div @click="addChecklist">
          <i class="icon iconfont iconicon_enlarge"></i>
        </div>
      </el-tooltip>
      <nothing v-if="!loading && (!dataset.project_template_content || !dataset.project_template_content.task_list || dataset.project_template_content.task_list.length == 0)" :config="{ tip: '暂无任务清单', btnText: '新建任务清单', type: 'img_no_data' }" @button-click="addChecklist"></nothing>
    </template>
    <FileManagement v-else></FileManagement>
    <AddChecklist @success="addTaskListSuccess" v-model="visibleAddChecklist"></AddChecklist>
    <AddTask v-if="showAddTask" v-model="showAddTask" @change="taskAddChange"></AddTask>
    <TaskDetail v-model="showTaskDetail" :openData="openData" v-if="showTaskDetail" @del="delTask"></TaskDetail>
    <CustomKeyDialog v-model="customVisible" v-if="customVisible"></CustomKeyDialog>
  </div>
</template>
<script>
import { mapState,mapMutations,  mapActions } from 'vuex'
import Breadcrumb from './breadcrumb'
import HeadKey from './headKey'
import Task from './task/task'
import { uuid } from '@/libs'
import vuedraggable from "vuedraggable";
import AddChecklist from './task/addCheckList'
import AddTask from './task/addTask'
import TaskDetail from './task'
import CustomKeyDialog from './customKeyPage'
import FileManagement from './fileManagement'
import ModeCheck from './modeCheck'
import api from '@/services/api/template'
export default {
  components: {
    Breadcrumb,
    HeadKey,
    Task,
    vuedraggable,
    AddChecklist,
    AddTask,
    TaskDetail,
    CustomKeyDialog,
    FileManagement,
    ModeCheck
  },
  data() {
    return {
      activeName: 'task',
      default_view: '1',
      moveKey: '',
      inputTitle: '',
      visibleAddChecklist: false,
      showAddTask: false,
      showTaskDetail: false,
      addItem: {},
      loading: false,
      openData: {},
      openIndex: 0,
      openListId: 0,
      customVisible: false,
      startWatch: false,
      isChange: false
    }
  },
  created() {
    this.init()

  },
  computed: {
    // ...mapState('template/template', {
    //   dataset: state => state.dataset
    // })
    dataset() {
      return this.$store.state['template/template'].dataset
    }
  },
  watch: {
    dataset: {
      handler() {
        if(this.startWatch) {
          this.isChange = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.isChange) {
      this.$wfAlert('', `模板未保存，是否保存?`, '', '保存', '', '', '退出').then(async () => {
        await this.saveTemplate()
        next()
      })
      .catch((err) => {
        next()
      })
    } else {
      next()
    }
  },
  methods: {
    ...mapMutations('template/template', ['task_del', 'task_add', 'task_update_id', 'set_data']),
    ...mapActions('template/template', ['task_find_id']),
    handleBack() {

    },
    changeTitle(item) {
      item.isTitleEdit = false;
    },
    subDragOptions(key) {
      return {
        animation: 200,
        group: key,
      }
    },
    enterTitleChange(ref) {
      this.$refs[ref][0].blur()
    },
    handleCommandAddtask(command) {
      if (command.type === "addTask") {
        this.addItem = command.item
        this.showAddTask = true
      }
      if (command.type === "delChecklist") {
        this.delChecklist(command.index);
      }
    },
    delChecklist(index) {
      if(this.dataset.project_template_content?.task_list[index]?.tasks && this.dataset.project_template_content?.task_list[index]?.tasks.length > 0) {
        this.$message({
          message: '包含任务的清单不可删除',
          type: 'error',
        })
        return
      }
      this.dataset.project_template_content?.task_list.splice(index, 1)
    },
    changeListShow(item) {
      this.$set(item, 'moreShow', !item.moreShow)
    },
    editTask() {

    },
    addTask(item) {
      this.addItem = item
      this.showAddTask = true
    },
    addChecklist() {
      this.visibleAddChecklist = true
    },
    editTitle(item, ref) {
      this.$set(item, 'isTitleEdit', true)
      this.inputTitle = item.title;
      this.$nextTick(() => {
        this.$refs[ref][0].focus()
      })
    },
    handleCommand(comm) {
      switch (comm.type) {
        case 'del':
          // 删除 （）
         this.delTask(comm?.dataset?.id)
          break
      }
    },
    async delTask(id) {
      if(!id) return
      await this.$wfAlert('warning', '删除后不可恢复，是否删除?', '', '确定')
      this.showTaskDetail = false
      this.task_del(id)
    },
    addTaskListSuccess(title) {
      this.visibleAddChecklist = false
      if(!this.dataset.project_template_content?.task_list) {
        this.dataset.project_template_content = {}
        this.dataset.project_template_content.task_list = []
      }
      this.dataset.project_template_content?.task_list.push({
        title,
        tasks: [],
        task_list_id: uuid()
      })
    },
    taskClick(val, index, id) {
      this.openData = val
      this.openIndex = index
      this.openId = id
      this.showTaskDetail = true
    },
    async init() {
      this.loading = true
      let id = this.$route.query.id
      let result = await api.projectTemplatesDetail({id})
      result?.project_template_content?.task_list?.map(res => {
        if(!res.task_list_id) {
          this.$set(res, 'task_list_id', uuid())
        }
        if (res.tasks) {
          res.tasks.map(temp => {
            !temp?.id ? this.$set(temp, 'id', uuid()) : ''
            !temp?.children ? this.$set(temp, 'children', []) : ''
            if(!temp.association_dependency) {
              temp.association_dependency = {
                post_tasks: [],
                pre_tasks: []
              }
            }
            if(temp.children) {
              temp.children.map(val => {
                !val?.id ? this.$set(val, 'id', uuid()) : ''
                !val?.children ? this.$set(val, 'children', []) : ''
                if(!val.association_dependency) {
                  val.association_dependency = {
                    post_tasks: [],
                    pre_tasks: []
                  }
                }
              })
            }
          })
        }
      })
      // result?.task_template_content?.template_standard_components.map((res) => {
      //   this.$set(res, 'is_show', Boolean(res.is_show))
      // })
      !result.project_attachments ? result.project_attachments = [] : ''
      this.set_data(result)
      this.loading = false
      this.$nextTick(() => {
        this.startWatch = true
        window.parent.postMessage('iframeLoaded', '*')
      })
    },
    taskAddChange(val) {
      this.dataset.project_template_content.task_list.find(res => {
        if(res.task_list_id === this.addItem.task_list_id) {
          if(!res.tasks) {
            res.tasks = []
          }
          res.tasks.unshift(val)
          return true
        }
      })
      this.showAddTask = false
    },
    showCustom() {
      this.customVisible = true
    },
    async saveTemplate() {
      await api.projectTemplatesSaveUpdate(this.dataset)
      this.isChange = false
      this.$message({
        message: '模板保存成功',
        type: 'success'
      })
    },
    async handleDelTemplate() {
      await this.$wfAlert('warning', `模板删除后不可恢复，是否删除？`, '', '删除')
      await api.projectTemplatesSaveDelete({id: this.dataset.id})
      this.$message({
        message: '模板删除成功',
        type: 'success'
      })
      this.isChange = false
      this.$router.go(-1)
    },
    end() {
      this.$forceUpdate()
    }
  },
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin.scss";
.template-project-detail {
  display: flex;
  flex-direction: column;
  flex: 1;
  .task-list-add {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background: linear-gradient(225deg, #2fa9ff 0%, #0d70e8 100%);
    position: absolute;
    right: 48px;
    bottom: 48px;
    line-height: 66px;
    text-align: center;
    box-shadow: 4px 6px 18px -3px #2fa9ff;
    cursor: pointer;
    z-index: 99;
    &:hover {
      background: linear-gradient(225deg, #107ce7 0%, #0764d4 100%);
    }
    i {
      color: #fff;
      margin: 0;
      font-size: 26px;
    }
  }
  .board-tip {
    height: 40px;
    background-color: #EDEDED;
    color: rgba(32, 32, 32, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    flex-shrink: 0;
  }

  >.header {
    background-color: #fff;
    position: relative;
    z-index: 3;
    flex-shrink: 0;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 12px;
      box-shadow: 0 5px 8px -3px rgba(13, 31, 60, .13);
    }
    .top {
      height: 72px;
      background: #fff;
      display: flex;
      padding: 0 32px;
      align-items: center;
    }
  }
  .tabs-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 0 none;
    position: relative;
    z-index: 3;
    padding-right: 27px;
    .el-tabs {
      margin-left: 28px;
      .el-tabs__item {
        font-size: 14px;
        font-weight: 500;
        @include fontColorOpacity(.6);
        &:hover {
          color: initial;
        }
      }
      .el-tabs__item.is-active {
        color: initial;
      }
    }
  }
  .tabs-right-box {
    display: flex;
    align-items: center;
    color: rgba(32, 32, 32, 0.6);
    .view-ch {
      display: flex;
      align-items: center;
      line-height: 1;
      margin-right: 28px;
    }
    .el-radio__label{
      color: rgba(32, 32, 32, 0.6);
    }
  }
.board-menu {
  display: flex;
  width: 100%;
  height: 0;
  flex: 1;
  overflow-y: hidden;
  box-sizing: border-box;
  position: relative;
  background-color: rgba(247, 247, 247, 1);
  &::-webkit-scrollbar {
      height: 24px;
      background-color: #EEEEEE;
  }
  &::-webkit-scrollbar-thumb {
      border-radius: 0;
      background-color: rgba(32,32,32,0.08);
      &:active, &:hover {
        background-color: #9199A7;
      }
  }
  &::-webkit-scrollbar-track-piece {
      background-color: transparent;
  }
  .task-level {
    margin-right: 16px;
  }
  .board-start {
    margin-right: 16px;
    background-color: rgba(246, 212, 117, 0.24);
    border-radius: 2px;
    width: 18px;
    height: 18px;
    text-align: center;
    line-height: 18px;
    i {
      font-size: 14px;
    }
  }
  .move-box {
    height: 100%;
    display: flex;
  }
  .title {
    max-width: 176px;
    cursor: pointer;
  }
  &::after {
    content: "";
    display: block;
    width: 1px;
    height: 100%;
    flex-shrink: 0;
  }
  .task-drag-box-f {
    width: 17px;
    display: flex;
    align-items: center;
  }
  .task-drag-box {
    font-size: 12px;
    color: #959ca9;
    visibility: hidden;
    margin-left: 4px;
    cursor: pointer;
    &:hover {
      color: #2682ff;
    }
  }
  .title-flex-box {
    font-size: 16px;
    display: flex;
    align-items: flex-end;
    font-weight: 400;
    flex: 1;
  }
  .dot-more {
    margin: 0 6px;
  }
  .board-menu-item:first-child {
    // margin-left: 16px;
  }
  .board-menu-item {
    position: relative;
    // margin: 9px 8px 16px 0;
    // border-radius: 5px;
    width: 288px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    // padding-bottom: 5px;
    border-right: 1px solid rgba(13, 37, 60, 0.08);
    background-color: #F7F7F7;
    &:hover {
      .task-drag-box {
        visibility: visible;
      }
      .btns-handler .dot-more {
        visibility: visible;
      }
    }
    .el-loading-mask {
      background-color: #F7F7F7;
    }
  }
  .finish_num {
    color: rgba(25, 24, 67, 0.6);
  }
  .total_num,
  .slash {
    color: rgba(32, 32, 32, 0.4);
  }
  .task-total {
    font-size: 12px;
    margin-left: 8px;
    font-weight: normal;
  }
  .board-content-title {
    display: flex;
    height: 72px;
    align-items: center;
    padding-right: 12px;
    .btns-handler {
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        @include fontColorOpacity(.6);
      }
      .dot-more {
        visibility: hidden;
      }
    }
  }
  .board-content {
    height: 0;
    overflow: auto;
    overflow: overlay;
    position: initial !important;
    flex: 1;
    &::-webkit-scrollbar-thumb {
      background-color: transparent;
    }
    .fo-header {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding: 0 16px;
      padding-bottom: 8px;
      background-color: rgba(247, 247, 247, 1);
      line-height: 1.3;
      .fo-all-check {
        margin-right: 8px;
      }
      .fo-header-text {
        padding-left: 6px;
        padding-right: 8px;
      }
      i {
         font-size: 12px;
         @include fontColorOpacity(.24);
      }
      .task-badge-head {
        width: 8px;
        height: 8px;
        background: linear-gradient(227deg, #7aa7e2 0%, #456fb3 100%);
        border-radius: 50%;
        position: absolute;
        right: 20px;
        bottom: 12px;
      }
      .fo-header-text-content {
        display: flex;
        align-items: center;
        .up-arrow {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          i {
            transition: all .3s;
          }
        }
      }

    }
  }
  .board-content-td {
    position: relative;
    width: 256px;
    max-height: 126px;
    margin: 0 auto 8px auto;
    flex-shrink: 0;
    background-color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    cursor: pointer;
    box-shadow: 0px 2px 4px 0px rgba(32,32,32,0.08);
    .task-create-date .task-left-item {
      margin-top: 18px;
    }
    .task-flex-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .task-left {
        display: flex;
        align-items: center;
      }
      .task-left-item {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-right: 17px;
        color: rgba(32, 32, 32, 0.6);
        i {
          font-size: 12px;
          margin-right: 6px;
        }
      }
    }
    .task-date {
      font-size: 13px;
      color: rgba(32,32,32,0.8);
      border-radius: 2px;
      margin-right: 16px;
    }
    .task-title-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      max-width: 100%;
      padding-right: 2px;
      font-weight: 500;
      line-height: 1.3;
      height: 28px;
      > div {
        flex-shrink: 0;
      }
    }
    .task-title-wrap-item {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      max-width: 74%;
      align-items: center;
      .task-check {
        display: flex;
        align-items: center;
        margin-right: 8px;
        flex-shrink: 0;
      }
    }
    &:before {
      content: "";
      width: 3px;
      height: 100%;
      position: absolute;
      background-color: rgba(255, 255, 255, 0);
      border-radius: 50px 0 0 50px;
      top: 0;
      left: 0;
      bottom: 0;
    }
    &:hover {
      .task-sn {
        visibility: visible;
      }
    }
  }
  .board-content---addlist {
    display: flex;
    .add-btn {
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      margin-top: 25px;
      margin-left: 10px;
      i {
        font-size: 14px;
        margin-right: 6px;
        color: rgba(32, 32, 32, 0.6);
      }
      span {
        padding: 4px 6px;
      }
    }
  }
  .board-top {
    flex: 1;
    padding: 14px 11px 13px 13px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .remind {
    .task-date {
      color: #ff8b23 !important;
    }
    &:before {
      background-color: #ff8b23 !important;
    }
  }
  .expired {
    .task-date {
      color: #ff3939 !important;
    }
    &:before {
      background-color: #ff3939 !important;
    }
  }
  .board-bottom {
    border-top: 1px solid #f8f9fb;
    height: 40px;
    line-height: 40px;
    padding-right: 14px;
    margin-left: 14px;
    .task-principal {
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }
    .task-principal .avatar-wrap {
      display: flex;
      align-items: center;
    }
    .task-principal .avatar-wrap .task-avatar {
      width: 26px;
      height: 26px;
      margin-right: 12px;
    }
    .task-sn {
      height: 16px;
      line-height: 16px;
      text-align: center;
      border-radius: 2px;
      font-size: 12px;
      color: rgba(25, 24, 67, 0.6);
      align-items: center;
      display: flex;
      visibility: hidden;
      .task-sn-nore {
        margin-left: 8px;
      }
    }
  }
  .task-sn-hover {
    display: block;
    text-align: center;
    cursor: pointer;
  }
  .task-sub-info {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 1;
  }
  .task-sub-info > i {
    font-size: 12px;
    margin-right: 7px;
  }
  .complete , .complete-task{
    * {
      color: rgba(32, 32, 32, 0.4) !important;
      opacity: 1;
      i {
        color: rgba(32, 32, 32, 0.4)  !important;
      }
    }
    .avatar-box {
      opacity: 0.4;
    }
    .task-level {
      color: rgba(32, 32, 32, 0.4) !important;
      background: rgba(32, 32, 32, 0.08) !important;
    }
    .task-sn i{
      color: initial !important;
    }
    .board-start {
      background-color: rgba(32, 32, 32, 0.08);
    }
  }
  .complete.board-content-td {
    background: #E1E0E0 !important;
    box-shadow: none;
    .board-bottom {
      border-color: rgba(13, 31, 60, 0.04);
    }
  }
  .add-task {
    width: 256px;
    margin: 0 auto;
    position: relative;
    z-index: 101;
  }
  .task-item-move {
    min-height: 2px;
    flex-shrink: 0;
  }
  .task-move-box {
    position: relative;
    padding-bottom: 16px;
  }
  .task-item-move-top {
    margin-top: -2px;
    position: relative;
  }
  .loading-box {
    font-size: 14px;
    text-align: center;
    color: #999;
    height: 30px;
    line-height: 30px;
    i {
      margin-right: 5px;
    }
  }
  .line-loading {
    height: 100%;
    margin-left: -10px;
    font-size: 20px;
    width: 30px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .task-badge {
    position: absolute;
    right: -1px;
    top: -1px;
    width: 8px;
    height: 8px;
    background: linear-gradient(227deg, #7aa7e2 0%, #456fb3 100%);
    border-radius: 50%;
    z-index: 999;
  }
  .title-input {
    display: flex;
    align-items: center;
    width: 0;
    flex: 1;
    .wf-button {
      flex-shrink: 0;
    }
  }
}
}


</style>"
